import { RegistrationFieldConfigModel } from "src/app/models/registration-field-configs/registration-field-config.model";
import { REGISTRATION_FIELD_KEYS } from "./registration-field.keys";

export const DEFAULT_REGISTRATION_FIELDS: RegistrationFieldConfigModel[] = [
  { 
    key: REGISTRATION_FIELD_KEYS.email, 
    visible: true, 
    required: true,
    order: 1, 
    isLocked: true 
  },
  { 
    key: REGISTRATION_FIELD_KEYS.firstName, 
    visible: true, 
    required: true, 
    order: 2,
    isLocked: true 
  },
  { 
    key: REGISTRATION_FIELD_KEYS.lastName, 
    visible: true, 
    required: true, 
    order: 3,
    isLocked: true 
  },
  { 
    key: REGISTRATION_FIELD_KEYS.iddNumber, 
    visible: true, 
    required: false, 
    order: 4 
  },
  { 
    key: REGISTRATION_FIELD_KEYS.agentNumber, 
    visible: false, 
    required: false, 
    order: 5 
  },
  { 
    key: REGISTRATION_FIELD_KEYS.companyName, 
    visible: false, 
    required: false, 
    order: 6 
  },
  { 
    key: REGISTRATION_FIELD_KEYS.phoneMobile, 
    visible: false, 
    required: false, 
    order: 7 
  }
];